module.exports = __webpack_public_path__ + "img/text.0a93e50a.png";